import axios from 'axios';
import * as Constants from "../common/constants";
import * as HelperFunctions from '../common/functions/helperFunctions';
import { ManufacturerFilterSettingsModel, ManufacturerAdminModel } from "../models/manufacturer";
import AuthService from './authService';

class RouteOfAdministrationService {
	authService = new AuthService();

	constructor() {
		axios.defaults.baseURL = `${Constants.apiUrl}/`;
		axios.defaults.headers = {
			"Content-Type": "application/json; charset=utf-8",
			Authorization: `Bearer ${this.authService.getToken()}`,
			Pragma: 'no-cache'
		}
	}

	getDropdownList() {
		return axios({
			url: `routeOfAdministration/getDropdownList/`,
			method: 'get', headers: {
				"Content-Type": "application/json; charset=utf-8"
			}
		})
			.then(res => res.data.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}
}

export default RouteOfAdministrationService;
